/* eslint-disable no-fallthrough */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
// import { putErrorNotification } from '@wix/da-shared-react/pkg/utils/saga';
import { isApiError, requestNapi, requestPuppy } from '@wix/da-http-client/pkg/request';
import { getConfigKey } from '@wix/da-redux-config/pkg/selectors';
import ddt from '@wix/da-ddt';
import { updateModule, fetchModuleEndpoint, fetchModuleEndpointSuccess, fetchModuleEndpointError, fetchModuleSuccess } from '../actions/modules';
import { getModuleVersion } from '../selectors/modules';
import { sampleModuleResponse } from '../sampleData';
import { getModuleDataFromPapiModule } from '../helpers';
// These are endpoints that write to draftJS they have to go via node
const POST_ENDPOINTS_THAT_NEED_NODE = [
    'about/save',
    'group_about/save',
    'papi_custombox/save',
    'donations/save',
    'papigroupabout/save',
    'megabox/save'
];
function* postModuleEndpoint(endpoint, params) {
    if (POST_ENDPOINTS_THAT_NEED_NODE.includes(endpoint)) {
        return yield call(requestNapi, {
            method: 'post',
            url: `/gruser/module/${endpoint}`,
            data: params
        });
    }
    return yield call(requestPuppy, {
        method: 'post',
        url: `module/${endpoint}`,
        data: params
    }, ()=>sampleModuleResponse, 'gruser');
}
function* getModuleEndpoint(endpoint, params) {
    return yield call(requestPuppy, {
        method: 'get',
        url: `module/${endpoint}`,
        params
    }, undefined, 'gruser');
}
const isModuleResponse = (response)=>response && response.hasOwnProperty('id') && response.hasOwnProperty('version') && response.hasOwnProperty('moduleData');
export function* runModuleInitActions(gruser, moduleId, moduleResponse, initActionsCreator) {
    // Duck typing
    if (!isModuleResponse(moduleResponse)) {
        return;
    }
    yield put(fetchModuleSuccess(gruser, moduleResponse));
    if (initActionsCreator) {
        const initActions = initActionsCreator(gruser, moduleId, getModuleDataFromPapiModule(moduleResponse));
        yield all(initActions.map((action)=>put(action)));
    }
}
export function* fetchModuleEndpointSaga(action) {
    const _ref = (action === null || action === void 0 ? void 0 : action.payload) || {}, { gruser } = _ref, payload = _object_without_properties(_ref, [
        "gruser"
    ]);
    const { id, path, method, options } = payload, data = _object_without_properties(payload, [
        "id",
        "path",
        "method",
        "options"
    ]);
    const version = yield select(getModuleVersion, gruser, id);
    const { gruserId, gruserTypeid, gruserItemid } = gruser;
    const csrf = yield select(getConfigKey, 'csrfToken');
    const fetchEndpoint = method === 'get' ? getModuleEndpoint : postModuleEndpoint;
    const response = yield call(fetchEndpoint, path, _object_spread_props(_object_spread({}, data), {
        csrf_token: csrf,
        version,
        gruserid: gruserId,
        gruser_typeid: gruserTypeid,
        gruser_itemid: gruserItemid,
        moduleid: id
    }));
    if (!response || isApiError(response)) {
        var _response_errorDetails;
        const errorDescription = (response === null || response === void 0 ? void 0 : (_response_errorDetails = response.errorDetails) === null || _response_errorDetails === void 0 ? void 0 : _response_errorDetails.Form) || (response === null || response === void 0 ? void 0 : response.details) || (response === null || response === void 0 ? void 0 : response.errorDescription);
        ddt.log(`modules`, `fetch action error`, `${errorDescription}`);
        // yield putErrorNotification(errorDescription);
        yield put(fetchModuleEndpointError(gruser, {
            id,
            path,
            errorDescription
        }));
        yield put(updateModule(gruser, {
            id,
            moduleMeta: {
                isFetching: false
            }
        }));
        return;
    }
    if (isModuleResponse(response)) {
        // update module data in the store
        yield runModuleInitActions(gruser, id, response, options === null || options === void 0 ? void 0 : options.initActionsCreator);
    } else {
        // endpoint does not return a module response, hence, no module version gets updated
        // module version is used as memoization key for many hooks, so if no version
        ddt.log(`modules`, `save endpoint does not return a module response`, {
            id,
            path,
            response
        });
    }
    yield put(fetchModuleEndpointSuccess(gruser, {
        id,
        response,
        path
    }));
}
export default function* rootModulesSaga() {
    yield all([
        takeEvery(fetchModuleEndpoint, fetchModuleEndpointSaga)
    ]);
}
